const VERSION = "100";

var dom = document.createElement("p");
dom.style.height = 0;
dom.style.overflow = "hidden";
dom.innerText = VERSION;
document.body.appendChild(dom)